import { Component, OnInit } from '@angular/core';
import { User } from '../../../../classes/User';
import { PROVINCES } from '../../../data/provinces';
import { ROLES } from '../../../data/roles';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit {

  id: number;
  isSubmitButtonDisabled: boolean = false;
  contentVisible: boolean = false;
  editUser: User = new User( );
  confirmPassword: string = '';

  hasNotes: boolean = false;
  notes: any[] = [];
  isRequiredNotesField: boolean = true;
  isRequiredPassword: boolean = false;
  isNotesWasEdited: boolean = false;

  user_active: boolean = true;
  managers: any[] = [];

  customAdmins = [];
  
  provinces = PROVINCES;
  roles = ROLES;

  availableRoles: string[] = [ 'admin' ];
  isAvailable: boolean = true;

  selectParams: any = {

    manager: {
      id: 'selectManager',
      isRequired: true,
      isDisabled: this.editUser.role == 'admin',
      change: ( event ) => { this.editUser.manager = event.value; },
      options: [ { text: '', value: '' } ]
    },
    
    role: {
      id: 'selectRole',
      isRequired: true,
      change: ( event ) => { 
        this.editUser.role = event.value; 
        this.selectParams.manager.isDisabled = event.value == 'admin';
      },
      options: [ { text: '', value: '' } ]
    },
    
    referredBy: {
      id: 'selectReferredBy',
      isRequired: true,
      change: ( event ) => { this.editUser.referredBy = event.value; },
      options: [ { text: '', value: '' } ]
    },

    state: {
      id: 'selectState',
      isRequired: true,
      change: ( event ) => { this.editUser.state = event.value; },
      options: [ { text: '', value: '' } ]
    }

  };

  constructor ( 
    private route: ActivatedRoute,
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Edit User' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) {
    
    this.provinces.forEach( _st => { this.selectParams.state.options.push( { text: _st.long, value: _st.short } ); });
    this.roles.forEach( _rl => { this.selectParams.role.options.push( { text: _rl.name, value: _rl.data } ); });

    this.route.params.subscribe( params => {
      this.id = +params['id'];
      this.model.getCustomAdmins( ( customAdmins ) => { 
        let _referredBy = [ { text: '', value: '' } ];
        this.customAdmins = customAdmins; 
        customAdmins.forEach( _user => { _referredBy.push( { text: _user.firstName + ' ' + _user.secondName, value: _user.id } ); });
        this.selectParams.referredBy.options = _referredBy;
        this.model.getUserDataByID( this.id, ( user ) => {
          this.contentVisible = true;
          this.getManagers( user );
        });
      });
       this.getNotes( );
    });
  }

  getManagers ( user ) {
    this.model.getUsersData( ( usersData ) => {
      let _managerOptions = [ { text: '', value: '' } ];
      usersData = usersData.json( );
      this.managers = usersData.users;
      user.notes = '';
      this.editUser = user;
      this.editUser.id = this.id;
      this.editUser.password = '';
      this.selectParams.manager.isDisabled = this.editUser.role == 'admin';
      usersData.users.forEach( _user => { _managerOptions.push( { text: _user.firstName + ' ' + _user.secondName, value: _user.id } ); });
      this.selectParams.manager.options = _managerOptions;
      this.user_active = this.editUser.status == 'active';
    }, { user_role: user.role, manager: true, status: 'active', not_empty_name: 'true' });  
  }

  getNotes ( ) {
    this.model.getNotes( 'user', this.id, ( notes ) => {
      this.notes = notes;
      this.hasNotes = notes.length != 0;
    });
  }

  addNote ( ) {
    this.model.addNote( 'user', this.id, this.editUser.notes, ( response ) => {
      this.getNotes( );
      this.isRequiredNotesField = false;
      this.isNotesWasEdited = true;
    });
  }

  showHistory ( ) { this.global.changeHPVisibility( true ); }

  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'User has been updated successfully', 
      redirect: '/users-list' 
    });
  }


  errorCallback ( message? ) {
    let _message = ( message ) ? message : 'We got some error here';
    let data = {
      messageType: 'error',
      message: _message,
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.global.defaultErrorCallback( _message, false );
    this.isSubmitButtonDisabled = false;

  }

  errorPasswords ( ) {
    let data = {
      messageType: 'error',
      message: 'Passwords don\'t match',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.global.defaultErrorCallback( 'Passwords don\'t match', false );
    this.isSubmitButtonDisabled = false;
  }

  checkPasswordRequire ( ) {
    if ( this.editUser.password != '' || this.confirmPassword != '' ) this.isRequiredPassword = true;
    else this.isRequiredPassword = false;
  }

  submitForm ( ) {

    this.isSubmitButtonDisabled = true;
    if ( this.editUser.password != this.confirmPassword && this.isRequiredPassword ) {
        this.errorPasswords( );
    } else {
      this.editUser.status = this.user_active ? 'active' : 'inactive';
      this.model.editUser( this.editUser, ( response ) => {
        let _answer = response.json( );
        _answer = _answer.answer;
        if ( _answer == 'success' ) this.successCallback( );
        else if ( _answer == 'exists' ) {
          this.errorCallback( 'User with email "'+this.editUser.email+'" already exists' );
        } else {
          this.errorCallback( );
        }
      });
    }
    return false;
  }

  cancelSubmit ( ) {
    this.global.redirect( '/users-list' );
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/users/edit-user/edit-user.component.ts